import { PermissionsEnum } from "@/auth/interfaces";
import CustomCoordendasForm from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm";
import {
  EstadosSolicitudEnumChoice,
  ROUTER_PATHS,
  TipoIdentificacionEnumChoice,
  fnPasarevision,
  formatHourHH,
  gridSize,
  gridSizeConst12,
  gridSizeMdLg10,
  gridSizeMdLg12,
  gridSizeMdLg6,
  handleErrorForm,
  texto,
  useCheckPermissions,
} from "@/shared";
import { postPoligono } from "@/shared/actions/erp";
import { useFetchPostPreagendamientoPymes } from "@/shared/actions/erp/operaciones/preagendamiento/preagendamiento_pymes.actions";
import {
  CustomAutocomplete,
  CustomTextArea,
  CustomTextFieldNoForm,
  SampleDatePicker,
  StepperBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import TimeClockComponente from "@/shared/components/ui/TimeClock/TimeClockComponente";
import TipoVentaCanjeEvento from "@/shared/components/ui/TipoVentaCanjeEvento/TipoVentaCanjeEvento";
import { useLocalidad } from "@/shared/hooks/useLocalidad";
import {
  AlertSeverityEnum,
  DescripcionPagoInstall,
  ErrorMessagesForm,
  NacionalidadEnum,
  Plan,
  Sector,
  TipoSolicitudesEnum,
} from "@/shared/interfaces";
import { IPreagendamientoPymesForm } from "@/shared/interfaces/erp/ventas_pymes/preagendamiento_pymes.interface";
import { InfoPuntoEnlace, IPreventaPymes } from "@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface";
import { newPreagendamientoPymesSchema } from "@/shared/utils/validation-schemas/erp/ventas/preagendamiento/preagendamientopyemes.schema";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import "dayjs/locale/es";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const steps = ["Informacion", "Servicio", "Instalación"];

interface SavePreagendamientoProps {
  title: string;
  uid: string;
  dataPreventa: IPreventaPymes;
}

export default function SavePreagendamientoPymes({
  title,
  uid,
  dataPreventa
}: SavePreagendamientoProps) {


  useCheckPermissions(PermissionsEnum.api_add_preagendamientopymes);

  ///* STATE
  const setAlert = useUiStore((s) => s.setAlert);
  const [dialogContrato, setDialogContrato] = useState(false);
  const [dataEnlace, setDataEnlace] = useState<InfoPuntoEnlace | undefined>(undefined);
  const [dataPlan, setDataPlan] = useState<Plan | undefined>(undefined);

  ///* FORMULARIO PARA PREVENTAS
  // PERF: interfaz flaca (era useForm<IPreagendamientoPymesForm>, explotaba Path<T>)
  const form = useForm<{ coordenadas: string; detalle_instalacion: string; distancia: string; distancia_polmax: string; fecha_instalacion: string; hora_instalacion: string; nap: string; sector: string }>({
    resolver: yupResolver(newPreagendamientoPymesSchema as any),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = form;


  ///* store
  const {
    dataSector,
    isLoadingSector
  } = useLocalidad({
    form: form as any,
    cobertura: true,
  });

  //FETCH

  const navigate = useNavigate();

  const {
    mutateAsync: createPreagendamiento,
    isPending: isPendingPreagendamiento,
  } = useFetchPostPreagendamientoPymes({
    navigate,
    returnUrl: ROUTER_PATHS.ventasPymes.preagendamientoNav
  });

  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);

  /* const {
    isLoadingNaps: isLoadingNapsByCity,
    getNaps,
    naps: napsByCity,
  } = useNapsStore(); */

  const {
    plans
  } = usePlanStore()

  useEffect(() => {

    if (!dataPreventa) return;

    if (dataPreventa?.estado_preventa != EstadosSolicitudEnumChoice.EN_ESPERA) {
      navigate(ROUTER_PATHS.ventas.preventasNav);
      setAlert(
        true,
        "Preagendamiento ya fue asiganado.",
        AlertSeverityEnum.info
      );
      return;
    }

    ///* obtener nap
    const puntoEnlace: any = dataPreventa.coordenadas.find(e => e.codigo == uid);
    form.setValue('coordenadas', `${puntoEnlace.lat},${puntoEnlace.lng}`);
    setDataEnlace(puntoEnlace);
    /* getNaps({
      lat: puntoEnlace?.lat,
      lng: puntoEnlace?.lng,
      page_size: 100,
    }); */

    ///* obtener información del plan 
    const planData = plans.find(e => e.codigo == puntoEnlace?.plan);
    setDataPlan(planData);
    reset({
      ...form.getValues(),
      detalle_instalacion: `EL PLAN "${planData?.nombre}" CON EL VALOR DE $${planData?.valor} TIENE UN COSTO DE INSTALACION $${puntoEnlace?.valor_instalacion_total} INCLUYE IVA." `,
    });

    ///* obtener localidad del servicio

    return () => {

    };
  }, [dataPreventa]);


  //* stepper
  const [activeStep, setActiveStep] = useState(0);
  const [disableNextStepBtn] = useState(false);
  const [skipped, setSkipped] = useState(new Set<number>());

  const handleNext = () => {
    let newSkipped = skipped;
    if (activeStep === steps.length - 1) return;
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const onSubmit = async (data: IPreagendamientoPymesForm) => {

    const {
      forma_pago_data,
      prospecto_pymes_data,
      codigo,
    } = dataPreventa

    try {

      data.descripcion_pago = fnPasarevision(
        forma_pago_data?.forma_pago || ""
      ) ? DescripcionPagoInstall.INSTALACION_GRATUITA
        : DescripcionPagoInstall.PENDIENTE;

      data.prospecto = prospecto_pymes_data.codigo;
      data.preventa = codigo;
      data.hora_instalacion = formatHourHH(form.getValues().hora_instalacion!)
      data.estado = true;
      //data.coordenadas = dataPreventa.coordenadas
      data.nombre_enlace = dataEnlace?.nombre;
      data.coordenadas = dataEnlace?.coordenada;
      data.codigo = dataEnlace?.codigo;
      data.es_canje = prospecto_pymes_data.solicitud_canje != null;
      data.es_evento = prospecto_pymes_data.solicitud_evento != null;

      //data.coordenadas = dataEnlace?.coordenada;
      const resp = await createPreagendamiento(data);

      if (resp.code === 200) {
        setAlert(
          true,
          "Preagendamiento creado correctamente.",
          AlertSeverityEnum.success
        );
        setDialogContrato(true)
        //navigate(ROUTER_PATHS.ventasPymes.preagendamientoNav);

      }
    } catch (error) {
    } finally {
      setIsGlobalLoading(false);
    }
  };

  useEffect(() => {

    if (!dataEnlace) return;
    async function obtenerLocalidad() {
      try {
        const resp = (await postPoligono({ latitud: dataEnlace?.lat!, longitud: dataEnlace?.lng! })).data;

        console.log(resp);

        reset({
          ...form.getValues(),
          pais: resp.pais,
          provincia: resp.provincia,
          ciudad: resp.ciudad,
          zona: resp.codigo,
        } as any)
      } catch (error) {
        setAlert(true, 'Lo sentimos ocurrio un error al obtener información de las coordenadas.', AlertSeverityEnum.error)
      }
    }
    obtenerLocalidad();
    return () => {

    }
  }, [dataEnlace])

  /* if (isLoadingNapsByCity)
    return <LoaderComponent />; */

  return (
    <StepperBoxScene
      titlePage={title}
      num_referencia={`${dataPreventa?.prospecto_pymes_data.razon_social} - L${dataPreventa.contrato_data?.linea}`}
      steps={steps}
      activeStep={activeStep}
      handleNext={handleNext}
      handleBack={handleBack}
      disableNextStepBtn={disableNextStepBtn}
      py={0}
      onCancel={async () => {
        navigate(ROUTER_PATHS.ventasPymes.preventaNav);
      }}
      onSave={handleSubmit(onSubmit, (error) => {
        handleErrorForm(error as ErrorMessagesForm);
      })}
      size={gridSizeMdLg10}
      additionalNoteText={
        <>

          <TipoVentaCanjeEvento
            tipo_venta={TipoSolicitudesEnum.PYMES}
            prospecto_data={dataPreventa.prospecto_pymes_data as any}
          />

          <Typography>Punto de Enlace: <b>{
            dataEnlace?.nombre
          }</b></Typography>


        </>
      }
    >
      {activeStep === 0 && (
        <Grid container spacing={3}>
          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={texto.informacion_personal}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.tipo_documento}
            defaultValue={dataPreventa?.prospecto_pymes_data.tipo_identificacion ?? 'N/A'}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.identificacion}
            defaultValue={dataPreventa?.prospecto_pymes_data.identificacion}
            size={gridSizeMdLg6}
          />
          <CustomTextFieldNoForm
            disabled={true}
            label={texto.nombre_apellido}
            defaultValue={dataPreventa?.prospecto_pymes_data.razon_social}
            size={gridSizeMdLg6}
          />

          {dataPreventa?.prospecto_pymes_data.tipo_identificacion !=
            TipoIdentificacionEnumChoice.RUC && (
              <>
                <CustomTextFieldNoForm
                  disabled={true}
                  label={texto.fecha_nacimiento}
                  defaultValue={dataPreventa?.prospecto_pymes_data.fecha_nacimiento}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={texto.edad}
                  defaultValue={dataPreventa?.prospecto_pymes_data.edad}
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={texto.nacionalidad}
                  defaultValue={
                    dataPreventa?.prospecto_pymes_data.nacionalidad ===
                      NacionalidadEnum.CODIGO
                      ? NacionalidadEnum.ECUATORIANA
                      : dataPreventa?.prospecto_pymes_data.nacionalidad
                  }
                  size={gridSizeMdLg6}
                />

                <CustomTextFieldNoForm
                  disabled={true}
                  label={texto.condicion_residencia}
                  defaultValue={dataPreventa?.condicion_residencia ?? 'N/A'}
                  size={gridSizeMdLg6}
                />
              </>
            )}

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={texto.datos_buros}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.segmentacion}
            defaultValue={dataPreventa?.prospecto_pymes_data.segmentacion}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.puntaje_score_empresa}
            defaultValue={dataPreventa?.prospecto_pymes_data.puntaje_score_empresa}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.puntaje_score_empresa}
            defaultValue={
              dataPreventa?.prospecto_pymes_data.puntaje_score_sobreendeudamiento
            }
            size={gridSizeMdLg6}
          />

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={texto.contacto_cliente}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.celular}
            defaultValue={dataPreventa?.prospecto_pymes_data.celular}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            required={false}
            label={texto.telefono_adicional}
            defaultValue={dataPreventa?.celular_2 ?? 'N/A'}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.email}
            defaultValue={dataPreventa?.email ?? 'N/A'}
            size={gridSizeMdLg6}
          />


        </Grid>
      )}

      {activeStep === 1 && (
        <Grid container spacing={3}>

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={'Representante Legal'}
              pt={0}
              mt={0}
              pb={1}
              pl={0}
            />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={'Tipo de Identificación'}
            defaultValue={dataPreventa?.representante_legal_tipo_identificacion}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={'Identificación'}
            defaultValue={dataPreventa?.representante_legal_identificacion ?? 'N/A'}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={'Razón Social'}
            defaultValue={dataPreventa?.representante_legal_razon_social ?? 'N/A'}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={'Celular 1'}
            defaultValue={dataPreventa?.representante_celular1 ?? 'N/A'}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={'Celular 2'}
            defaultValue={dataPreventa?.representante_celular2 ?? 'N/A'}
            size={gridSizeMdLg6}
          />


          <Grid item xs={12}>
            <TabTextLabel text={texto.servicio} mt={0} pb={0} pl={0} pt={0} />
          </Grid>

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.tipo_servicio}
            defaultValue={dataPlan?.tipo_servicio}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.plan}
            defaultValue={dataPlan?.nombre}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.velocidad_internet}
            defaultValue={dataPlan?.velocidad_subida_maxima + " " + dataPlan?.unidad}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.tipo_instalacion}
            defaultValue={dataPreventa?.tipo_instalacion}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.valor_instalacion}
            defaultValue={dataEnlace?.valor_instalacion || ""}
            size={gridSizeMdLg6}
          />

          <CustomTextFieldNoForm
            disabled={true}
            label={texto.valor_instalacion_total}
            defaultValue={dataEnlace?.valor_instalacion_total ?? 'N/A'}
            size={gridSizeMdLg6}
          />


        </Grid>
      )}

      {activeStep === 2 && (
        <Grid container spacing={3}>


          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={'Coordenada del servicio'}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomCoordendasForm
            disabled={true}
            size={gridSizeConst12}
            //key={field.id}
            label={`Punto de enlace`}
            //name={`coordenada_${index}`}
            defaultValue={dataEnlace?.coordenada ?? '0,0'}
            name={`coordenada`}
            form={form}
            canDragMarker={false}
            canLocationSearch={false}
            onlyValueLocation={true}

          />

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={texto.instalaciones}
              pt={0}
              mt={0}
              pb={0}
              pl={0}
            />
          </Grid>

          <CustomTextArea
            disabled={true}
            label={texto.detalle_instalacion}
            name="detalle_instalacion"
            control={form.control}
            defaultValue={form.getValues().detalle_instalacion}
            error={errors.detalle_instalacion}
            helperText={errors.detalle_instalacion?.message}
            required={false}
            rows={3}
          />

          {/* <CustomAutocomplete<Naps>
            size={gridSizeMdLg4}
            label="Seleccionar NAP"
            name="nap"
            options={napsByCity}
            valueKey="nombre"
            actualValueKey="codigo"
            defaultValue={undefined}
            isLoadingData={false}
            control={form.control}
            error={errors.nap}
            helperText={errors.nap?.message}
            onChangeRawValue={(rawValue) => {

              reset({
                ...form.getValues(),
                distancia: rawValue.distancia.toFixed(0),
                distancia_polmax: rawValue.distancia_polmax.toFixed(0),
              })

            }
            }
          />

          <CustomNumberTextField
            disabled={true}
            name="distancia"
            label={"Distancia"}
            defaultValue={form.getValues().distancia || ""}
            control={form.control}
            error={errors.distancia}
            helperText={errors.distancia?.message}
            endAdornment={
              <InputAdornment position="start">
                <Typography variant="body2">Metros</Typography>
              </InputAdornment>
            }
            size={gridSizeMdLg4}
          />

          <CustomNumberTextField
            disabled={true}
            name="distancia_polmax"
            label={"Distancia Max."}
            defaultValue={form.getValues().distancia_polmax || ""}
            control={form.control}
            error={errors.distancia_polmax}
            helperText={errors.distancia_polmax?.message}
            endAdornment={
              <InputAdornment position="start">
                <Typography variant="body2">Metros</Typography>
              </InputAdornment>
            }
            size={gridSizeMdLg4}
          /> 

          <Grid item xs={12}>
            <Typography
              variant="subtitle2"
              style={{
                color: "#6C737F",
              }}
            >
              Nota: Los valores de Distancia y Distancia Máx. son solo
              referencias para la distancia aproximada entre la NAP y la
              ubicación del enlace.
            </Typography>
          </Grid>*/}

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={'Seleccionar Sector'}
              pt={0}
              mt={0}
              pb={1}
              pl={0}
            />
          </Grid>

          <CustomAutocomplete<Sector>
            size={gridSize}
            label="Seleccionar Sector"
            name="sector"
            // options
            options={dataSector?.data.data || []}
            valueKey="nombre" // name is the fk
            actualValueKey="codigo"
            defaultValue={form.getValues().sector}
            isLoadingData={isLoadingSector}
            control={form.control}
            error={errors.sector}
            helperText={errors.sector?.message}
            onChangeValue={(cod) => {
              form.setValue('sector', cod)
            }}
          />

          {/*SELECION DE FECHA Y HORA DE INSTALACION*/}

          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel
              text={'Fecha y hora de instalación'}
              pt={0}
              mt={0}
              pb={1}
              pl={0}
            />
          </Grid>


          <SampleDatePicker
            minDate={new Date}
            label="Fecha de instalación"
            control={form.control}
            error={errors.fecha_instalacion}
            helperText={errors.fecha_instalacion?.message}
            name="fecha_instalacion"
            textFieldKey="fecha_instalacion"
            defaultValue={null}
            size={gridSizeMdLg6}
          />

          <TimeClockComponente
            size={gridSizeMdLg6}
            control={form.control}
            error={errors.hora_instalacion}
            helperText={errors.hora_instalacion?.message}
            label='Hora de instalación'
            name='hora_instalacion'
            enableDateTypeResult={false}
          />
        </Grid>
      )}



      {!isPendingPreagendamiento && dialogContrato && (
        <Dialog open={dialogContrato}>
          <DialogTitle>{"¡Preagendamiento creado con éxito!"}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} justifyContent={"end"}>
              <Grid item xs={12}>
                <Typography>
                  {`El siguiente paso es coordinar con el departamento correspondiente. Puedes dar seguimiento al proceso en el módulo de agendamiento.`}
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={() => {
                setDialogContrato(false);
                navigate(ROUTER_PATHS.ventasPymes.preagendamientoNav);
              }}
            >
              {"Salir"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </StepperBoxScene>
  );
}
